// LayoutContext.js
import { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const LayoutContext = createContext();

const LayoutProvider = ({ children }) => {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [apiToken, setApiToken] = useState('');
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [userInformation, setUserInformation] = useState(null);
  const [clockedIn, setClockedIn] = useState(null);
  const [calenderEvent, setCalenderEvent] = useState([]);
  const [mainLoader, setMainLoader] = useState(true);
  const [employeeEditData, setEMployeeEditDate] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [companyInfoLoaded, setCompanyInfoLoaded] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [selectedResume, setSelectedResume] = useState(null);
  const navigate = useNavigate();
  const handleLogout = (e) => {
    e.preventDefault();
    setUserLoggedIn(false);
    // Remove only session-related items (keep "Remember Me" data)
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('emailId');
    navigate('/');
  };
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  useEffect(() => {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      setUserLoggedIn(true);
    } else {
      setUserLoggedIn(false);
    }
  }, []);
  return (
    <LayoutContext.Provider
      value={{
        userLoggedIn,
        setUserLoggedIn,
        handleLogout,
        isMobile,
        mobileMenuOpen,
        setMobileMenuOpen,
        apiToken,
        setApiToken,
        currentUserRole,
        setCurrentUserRole,
        userInformation,
        setUserInformation,
        clockedIn,
        setClockedIn,
        calenderEvent,
        setCalenderEvent,
        mainLoader,
        setMainLoader,
        employeeEditData,
        setEMployeeEditDate,
        logoUrl,
        setLogoUrl,
        companyInfoLoaded,
        setCompanyInfoLoaded,
        companyName,
        setCompanyName,
        selectedResume,
        setSelectedResume,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export { LayoutContext, LayoutProvider };
